<template>

	<v-row class="mt-5 mb-5">

		<v-col offset-lg="4" lg="4" offset-md="3" md="6" offset-sm="2" sm="8">
		
			<form @submit.prevent="forgot()">

				<v-card class="pa-4" style="background: #101010;" elevation="20">


					<div class="text-center mb-3">
	    			<router-link to="/">
	    				<img src="@/assets/img/logo.png" width="150">
	    			</router-link>
	    		</div>

					<h3 class="text-center mt-3 mb-5" style="color: white;">Recuperar contraseña</h3>

					<v-text-field
						type="email"
	          label="Correo electrónico"
	          v-model="user.email" 
	          filled
	          dark
	          required
	        ></v-text-field> 	
			    

			    <!-- Alert wait -->
			    <v-alert class="info text-center" v-if="wait">
	        	Espera un momento por favor...
	      	</v-alert>


	        <v-btn type="submit" x-large block id="forgot-form-btn">
			      Recuperar contraseña
			    </v-btn>


			    <p class="mt-5 mb-3 text-center">
			    	<small style="color: gray">&copy; 2023 WOW ENVÍOS</small>
			    </p>

				</v-card>

			</form>
		
		</v-col>

  </v-row>

</template>


<script>
	
	import UserService from '@/shared/services/UserService'

	export default 
	{

		data() { 
			return {
				user: {
					email: null
				},

				wait: false
			}
		},

	  methods: {

			async forgot()
			{
				this.wait = true

				const resp = await UserService.forgotPassword(this.user)

				console.log(resp.data)
				
				if(resp.data == 'OK')
					SwalAlert('', 'Link de recuperación enviado a: ' + this.user.email, 'success')

				else if(resp.data == 'EMAIL_NOEXIST')
					SwalAlert('', 'El correo electrónico ingresado no se encuentra en nuestros registros', 'error')


				this.wait = false
			}

		}
	}

</script>